import { usersApi } from "api/User/api.ts";

import GetMeRequest = App.Http.Requests.User.GetMeRequest;

const FIVE_MINUTES = 5 * 60 * 1000;
const ONE_DAY = 24 * 60 * 60 * 1000;
const SESSION_REVALIDATION_INTERVAL = 30 * 1000;

export const TENANT_CONTEXT_STALE_TIME = FIVE_MINUTES;

const ME_TENANTS_REQUEST: GetMeRequest = {
    filter: {
        include: "tenants,tenants.roles",
    },
};

export function composeGetMeQueryOptions(request: GetMeRequest) {
    return {
        queryKey: ["me", request],
        queryFn: () => usersApi.getMe(request),
        staleTime: 0,
        gcTime: 0,
    };
}

export function getMeQueryOptions(request: GetMeRequest) {
    return {
        ...composeGetMeQueryOptions(request),
        suspense: true,
    };
}

export function getMeSessionQueryOptions() {
    return {
        ...composeGetMeQueryOptions({}),
        staleTime: SESSION_REVALIDATION_INTERVAL,
        gcTime: ONE_DAY,
    };
}

export function getMeTenantsQueryOptions() {
    return {
        ...composeGetMeQueryOptions(ME_TENANTS_REQUEST),
        staleTime: TENANT_CONTEXT_STALE_TIME,
        gcTime: ONE_DAY,
    };
}

export function getMeTenantPermissionsQueryOptions(tenantSlug: string, silentError = false) {
    return {
        queryKey: ["me", "tenantPermissions", tenantSlug],
        queryFn: () => usersApi.getMeTenantPermissions(tenantSlug, silentError),
        staleTime: TENANT_CONTEXT_STALE_TIME,
        gcTime: ONE_DAY,
    };
}
